import React from 'react';
import { Card, CardActionArea, Typography } from '@mui/material';
import { InstrumentItem, InstrumentItemProps } from './instrument-item';
import {
  DynamicPageEventKeys,
  DynamicPageEvents,
} from 'src/components/containers/dynamic-page/events';
import { EventBus } from '@/shared/utils';
import { LazyBackgroundImage } from 'src/shared/ui/lazy-background-image';

export interface TeacherPromoCardProps {
  imageUrl?: string;
  name: string;
  instruments: InstrumentItemProps[];
  href?: string;
  eventBus: EventBus<DynamicPageEvents>;
}

export const TeacherPromoCard: React.FC<TeacherPromoCardProps> = ({
  imageUrl,
  name,
  instruments,
  href,
  eventBus,
}) => {
  return (
    <Card
      onClick={() => {
        if (href)
          eventBus.emit(DynamicPageEventKeys.redirects.to, {
            url: href,
            isExternalPage: true,
          });
      }}
      className="min-w-[300px] bg-paper rounded-2xl"
    >
      <CardActionArea className="flex flex-col justify-start w-full rounded h-full">
        <div className="relative w-full">
          {/* Profile Image */}
          <div className="p-2">
            <LazyBackgroundImage
              src={imageUrl || ''}
              placeholder="/assets/images/placeholder/card-placeholder.png"
              className="h-[180px] w-full rounded-xl"
              style={{
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
          </div>
          {/* Content */}
          <div className="px-4 pb-4 pt-2">
            <Typography variant="h5" className="mb-2" component="h4">
              {name}
            </Typography>
            <div className="flex gap-x-4 gap-y-2 flex-wrap">
              {instruments.map((instrument, index) => (
                <InstrumentItem key={index} image={instrument.image} name={instrument.name} />
              ))}
            </div>
          </div>
        </div>
      </CardActionArea>
    </Card>
  );
};
